import React, { useEffect, useState } from "react";
import Header2 from "../components/Header2";
import Hero from "../components/Hero";
import Features from "../components/Features";
import Scoring from "../components/Scoring";
import Trade from "../components/Trade";
import Analysed from "../components/Analysed";
import Scroll from "../components/Scroll";
import Footer from "../components/Footer";

const Homepage = () => {
  const [visibleSections, setVisibleSections] = useState(new Set());

  // Prevent horizontal overflow globally
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';
    
    return () => {
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
    };
  }, []);

  useEffect(() => {
    let observer = null;
    
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      // Intersection Observer to detect when sections enter viewport
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const sectionId = entry.target.dataset.sectionId;
              setVisibleSections((prev) => new Set([...prev, sectionId]));
            }
          });
        },
        {
          threshold: 0.1, // Trigger when 10% of section is visible
          rootMargin: '0px 0px -50px 0px', // Trigger slightly before section fully enters
        }
      );

      // Find and observe all section elements
      const sectionSelectors = ['.hero', '.features', '.scoring', '.trade', '.analysed'];
      
      sectionSelectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          const sectionId = selector.replace('.', '');
          element.dataset.sectionId = sectionId;
          // Add initial styles for animation
          element.style.opacity = '0';
          element.style.transform = 'translateY(30px) translateX(0)';
          element.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
          element.style.willChange = 'opacity, transform';
          observer.observe(element);
        }
      });
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      if (observer) {
        const sectionSelectors = ['.hero', '.features', '.scoring', '.trade', '.analysed'];
        sectionSelectors.forEach((selector) => {
          const element = document.querySelector(selector);
          if (element) {
            observer.unobserve(element);
          }
        });
      }
    };
  }, []);

  // Apply styles when sections become visible
  useEffect(() => {
    visibleSections.forEach((sectionId) => {
      const element = document.querySelector(`.${sectionId}`);
      if (element) {
        element.style.opacity = '1';
        element.style.transform = 'translateY(0) translateX(0)';
      }
    });
  }, [visibleSections]);

  return (
    <>
      <Header2 />
      <main className="main" style={{ overflowX: 'hidden' }}>
        <div className="home">
          <Hero />
          <Features />
          <Scoring />
          <Trade />
          <Analysed />
          <Scroll />
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Homepage;